import React from "react";
import { useParams, useNavigate } from "react-router-dom";

function ProgramDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    // TEMP DATA (later replace with API)
    const programsData = [
        {
            id: 1,
            title: "Mental Health Awareness Workshop",
            image: "/Content/img/slide/BNT9.jpg",
            date: "2024-03-12",
            description: "An interactive workshop focused on mental health awareness in the South Asian community.",
            audience: "Youth, Adults, Families",
            location: "Edmonton Community Center",
            frequency: "One-time event",
            buttonText: "Register Now"
        },
        {
            id: 2,
            title: "Youth Empowerment Program",
            image: "/Content/img/slide.jpg",
            date: "2024-02-20",
            description: "Helping youth build confidence, leadership, and life skills.",
            audience: "Teenagers & Young Adults",
            location: "Online + In-person",
            frequency: "Monthly",
            buttonText: "Join Program"
        },
        {
            id: 3,
            title: "Community Support Meetup",
            image: "/Content/img/NewBNT192.jpg",
            date: "2024-01-10",
            description: "Safe space for community members to share and support each other.",
            audience: "Open to All",
            location: "Beaumont Hall",
            frequency: "Weekly",
            buttonText: "Contact Us"
        },
        {
            id: 4,
            title: "Community Support Meetup",
            image: "/Content/img/NewBNT192.jpg",
            date: "2024-01-10",
            description: "Safe space for community members to share and support each other.",
            audience: "Open to All",
            location: "Beaumont Hall",
            frequency: "Weekly",
            buttonText: "Contact Us"
        },
        {
            id: 5,
            title: "Community Support Meetup",
            image: "/Content/img/NewBNT192.jpg",
            date: "2024-01-10",
            description: "Safe space for community members to share and support each other.",
            audience: "Open to All",
            location: "Beaumont Hall",
            frequency: "Weekly",
            buttonText: "Contact Us"
        }
    ];

    const program = programsData.find(p => p.id === parseInt(id));

    if (!program) {
        return <h2 className="text-center mt-5">Program Not Found</h2>;
    }

    const dateObj = new Date(program.date);
    const formattedDate = dateObj.toDateString();

    return (
        <div>

            {/* Hero */}
            <div className="programHero" style={{ backgroundImage: `url(${program.image})` }}>
                <div className="overlay">
                    <h1>{program.title}</h1>
                </div>
            </div>

            <div className="container py-5">

                <button className="btn btn-secondary mb-4" onClick={() =>  (-1)}>
                    ← Back
                </button>

                <div className="row">

                    {/* Left Content */}
                    <div className="col-lg-8">

                        <p className="text-muted mb-3">
                            {formattedDate}
                        </p>

                        <h4 className="mb-3">About Program</h4>
                        <p className="programDesc">{program.description}</p>

                    </div>

                    {/* Right Info Card */}
                    <div className="col-lg-4">

                        <div className="programInfoCard">

                            <h5 className="mb-3">Program Details</h5>

                            <p><strong>Audience:</strong><br />{program.audience}</p>

                            <p><strong>Location:</strong><br />{program.location}</p>

                            <p><strong>Frequency:</strong><br />{program.frequency}</p>

                            <button className="btn btn-primary w-100 mt-3">
                                {program.buttonText}
                            </button>

                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}

export default ProgramDetail;